module.exports = __webpack_public_path__ + "static/IWGHQI1-7c0f9c3ee9992a070abed1d9637badcd.jpg";